import { push } from "connected-react-router";
import React, { useState, useMemo } from "react";
import {
  ROUTE_PATH,
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  ERROR_CODE,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
} from "../../app/constants";
import { useDispatch, useSelector } from "react-redux";
import { GetProviceCodeFromName, ValidateString } from "../../app/utils";
import { CanadaProvinceList } from "../../app/constants";
import { Button, ErrorMark, LineSeperator } from "../../components/RegularComponents";
import {
  ERROR_STRING,
  VALIDATION_TYPE,
  VALIDATION_ERROR,
  homeAddressErrorString,
  postalCodeErrorString,
  cityErrorString,
} from "../../app/errors";
// import { ERROR_STRING } from "../../app/errors";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { ErrorWithString } from "../../components/RegularComponents";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";
import styles from "./ml.module.scss";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils';

const APPOINTED_AGENT_MORTGAGE_APPLICATION_PROPERTY = "responsibleAgent";
const SERVICE_ADDRESS_MORTGAGE_APPLICATION_PROPERTY = "serviceBusinessAddress";

export const AppointedAgentServiceAddress = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW;
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const appointedAgent = useSelector(
    (state) =>
      state.primaryAgencyApplication.application?.businessLicenceData
        ?.responsibleAgent ?? {}
  );

  const serviceBusinessAddress = useSelector(
    (state) => 
      state.primaryAgencyApplication.application?.businessLicenceData
          ?.serviceBusinessAddress ?? {}
  )

  const [firstName, setFirstName] = useState(appointedAgent?.firstName ?? "");
  const [lastName, setLastName] = useState(appointedAgent?.lastName ?? "");
  const [firstNameError, setFirstNameError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [lastNameError, setLastNameError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [civicAddress, setCivicAddress] = useState(
    serviceBusinessAddress?.street ?? ""
  );
  const [civicAddressError, setCivicAddressError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );
  const [city, setCity] = useState(
    serviceBusinessAddress?.city ?? ""
  );
  const [province, setProvince] = useState(
    serviceBusinessAddress?.province ?? ""
  );
  const [cityError, setCityError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(false);
  const [provinceError, setProvinceError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [postalCode, setPostalCode] = useState(
    serviceBusinessAddress?.postalCode ?? ""
  );
  const [postalCodeError, setPostalCodeError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );

  // useEffect(() => {
  //   civicAddressError === VALIDATION_ERROR.NO_ERROR &&
  //   cityError === VALIDATION_ERROR.NO_ERROR &&
  //   postalCodeError === VALIDATION_ERROR.NO_ERROR
  //     ? setShowValidationError(false)
  //     : setShowValidationError(true);
  // }, [civicAddressError, cityError, postalCodeError]);

  const provinceOptionElements = useMemo(() => {
    return Object.keys(CanadaProvinceList).map((key) => {
      const element = CanadaProvinceList[key];
      return (
        <option key={key} value={element}>
          {element}
        </option>
      );
    });
  }, []);

  const validateData = () => {
    const ret1 = ValidateString(firstName, VALIDATION_TYPE.STRING_NON_EMPTY);
    setFirstNameError(ret1);

    const ret1_1 = ValidateString(lastName, VALIDATION_TYPE.STRING_NON_EMPTY);
    setLastNameError(ret1_1);

    const ret2 = ValidateString(civicAddress, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCivicAddressError(ret2);

    const ret3 = ValidateString(city, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCityError(ret3);

    const ret4 = ValidateString(GetProviceCodeFromName(province), VALIDATION_TYPE.CANADA_PROVINCE_CODE);
    setProvinceError(ret4);

    const ret5 = ValidateString(postalCode, VALIDATION_TYPE.CANADA_POSTAL_CODE);
    setPostalCodeError(ret5);

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR &&
        ret1_1 === VALIDATION_ERROR.NO_ERROR &&
        ret2 === VALIDATION_ERROR.NO_ERROR &&
        ret3 === VALIDATION_ERROR.NO_ERROR &&
        ret4 === VALIDATION_ERROR.NO_ERROR &&
        ret5 === VALIDATION_ERROR.NO_ERROR
    );
  };

  const handleNext = () => {
    setApplicationSaveError(false);
    //reset errors
    setShowValidationError(false);
    setFirstNameError(VALIDATION_ERROR.NO_ERROR);
    setLastNameError(VALIDATION_ERROR.NO_ERROR);
    setCivicAddressError(VALIDATION_ERROR.NO_ERROR);
    setCityError(VALIDATION_ERROR.NO_ERROR);
    setProvinceError(VALIDATION_ERROR.NO_ERROR);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return;
    }

    const appointedAgentUpdate = {
      ...appointedAgent, 
      firstName, 
      lastName
    }

    dispatch(setMortgageProperty({
      key : APPOINTED_AGENT_MORTGAGE_APPLICATION_PROPERTY, 
      value : appointedAgentUpdate
    }))

    const serviceAddressUpdate = {
      ...serviceBusinessAddress,
      street : civicAddress,
      city : city, 
      postalCode : postalCode,
      province : province
    }

    dispatch(setMortgageProperty({
      key : SERVICE_ADDRESS_MORTGAGE_APPLICATION_PROPERTY, 
      value : serviceAddressUpdate
    }))

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        const nextRoutePath = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) ? 
                                ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
        dispatch(
          !isModal
            ? push(
                `${nextRoutePath}${ROUTE_PATH.ML_FISCAL_END_DATE}`
              )
            : onEditSave()
        );
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    setFirstNameError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
    setLastNameError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleCivicAddressChange = (e) => {
    setCivicAddress(e.target.value);
    setCivicAddressError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
    setCityError(VALIDATION_ERROR.NO_ERROR);
  };

  const handlePostalCodeChange = (e) => {
    setPostalCode(e.target.value);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar 
                {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW} />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-10">
              <h1>Appointed agent and address for service in Nova Scotia</h1>
            </div>
          </div>
        </>
      )}

      {/* Name */}
      <div style={{ marginTop: "30px" }} className="row">
        <div className="col-lg-8">
          <h3>Appointed agent</h3>
        </div>
        <div className="col-lg-8">
          <div 
            className={
                "ns-fieldset" +
                ((firstNameError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
          <fieldset className="ns-fieldset">
            <label
              id={"appointed-agent-first-name-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"appointed-agent-first-name-text"}
            >
              First name
            </label>
            {firstNameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"appointed-agent-first-name-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_FIRST_NAME_EMPTY)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (firstNameError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"appointed-agent-first-name-text"}
              name={"appointed-agent-first-name-text"}
              value={firstName}
              onChange={handleFirstNameChange}
            />
          </fieldset>
          </div>
        </div>
        <div className="col-lg-8">
          <div
            className={
              "ns-fieldset" +
              ((lastNameError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            }
          >
          <fieldset className="ns-fieldset">
            <label
              id={"appointed-agent-last-name-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"appointed-agent-last-name-text"}
            >
              Last name
            </label>
            {lastNameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"appointed-agent-last-name-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_LAST_NAME_EMPTY)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (lastNameError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"appointed-agent-last-name-text"}
              name={"appointed-agent-last-name-text"}
              value={lastName}
              onChange={handleLastNameChange}
            />
          </fieldset>
        </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <LineSeperator />
        </div>
      </div>

      {/* CivicAddress */}
      <div className="row">
        <div className="col-lg-8">
          <h3>Service address</h3>
        </div>
        <div className="col-lg-8">
          <div 
            className={
              "ns-fieldset" +
              ((civicAddressError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            }
          >
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-lender-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-lender-licence-number-text"}
            >
              Civic Address
            </label>
            {civicAddressError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-lender-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(homeAddressErrorString(civicAddressError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (civicAddressError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-lender-licence-number-text"}
              name={"mortgage-lender-licence-number-text"}
              value={civicAddress}
              onChange={handleCivicAddressChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* City */}
      <div className="row">
        <div className="col-lg-8">
          <div className={
              "ns-fieldset" +
              ((cityError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            }>
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-lender-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-lender-licence-number-text"}
            >
              City
            </label>
            {cityError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-lender-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(cityErrorString(cityError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (cityError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-lender-licence-number-text"}
              name={"mortgage-lender-licence-number-text"}
              value={city}
              onChange={handleCityChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Province Select section */}
      <div className="row">
        <div className="col-lg-8">
          <div
            className={
              "ns-fieldset" +
              (provinceError !== VALIDATION_ERROR.NO_ERROR ? " has-error ns-fieldset-message-error" : "")
            }
          >
            <label
              id={"mra-province-select-label"}
              className="ns-label"
              htmlFor={"mra-province-select-input"}
            >
              Province
            </label>
            {provinceError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mra-province-select-input-error"}
                className="ns-error-message fieldset-validation-error"
              >
                {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_PROVINCE_EMPTY)}
              </span>
            )}
            <div className="select fw-25 inlineDisplay">
              <select
                className={provinceError !== VALIDATION_ERROR.NO_ERROR ? "select--error" : ""}
                style={{ width: "25em" }}
                id={"mra-province-select-input"}
                name={"mra-province-select-input"}
                value={province}
                onChange={(e) => {
                  setProvince(e.target.value);
                  setProvinceError(VALIDATION_ERROR.NO_ERROR)
                }}
              >
                {provinceOptionElements}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Postal Code */}
      <div className="row">
        <div className="col-lg-8">
          <div className={
              "ns-fieldset" +
              ((postalCodeError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            }
          >
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-lender-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-lender-licence-number-text"}
            >
              Postal Code
            </label>
            {postalCodeError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-lender-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(postalCodeErrorString(postalCodeError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (postalCodeError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-lender-licence-number-text"}
              name={"mortgage-lender-licence-number-text"}
              value={postalCode}
              onChange={handlePostalCodeChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Save and continue */}
      <div className="row">
        <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
          <Button
            className={`${styles["question_button"]} btn-lg btn-default`}
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            onClick={handleNext}
            text={!isModal ? "Save and next" : "Save and close"}
          />
          {applicationSaveError && !isModal && ErrorMark()}
          {applicationSaveError && !isModal && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
          {showValidationError && ErrorMark()}
          {showValidationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
